import { PathsV1CompanySearchPostParametersQuerySelect } from "@/api-schema-enums";
import { useCompanySearchQuery } from "@/common/api/company/use-company-search.query";
import { SearchableSelect } from "@/components/ui/searchable-select";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

interface BcaCompanySelectorProps {
  value?: string;
  onValueChange: (uuid: string | null) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
}

export function BcaCompanySelector({
  value,
  onValueChange,
  disabled,
  className,
  id,
}: BcaCompanySelectorProps): ReactElement {
  const { t } = useTranslation(["fit"]);
  const { data: companies, isLoading } = useCompanySearchQuery({
    options: {
      parameters: {
        pageSize: -1,
        select: [
          PathsV1CompanySearchPostParametersQuerySelect.Uuid,
          PathsV1CompanySearchPostParametersQuerySelect.Name,
        ],
      },
      body: {},
    },
  });

  const options = (companies?.data ?? []).map((company) => ({ value: company.uuid, label: company.name }));

  return (
    <SearchableSelect
      id={id}
      className={className}
      options={options}
      value={value ?? ""}
      onValueChange={(uuid) => onValueChange(uuid || null)}
      placeholder={t("fit:SelectBcaCompany")}
      searchPlaceholder={t("fit:SearchCompany")}
      emptyText={t("fit:NoCompanyFound")}
      disabled={disabled || isLoading}
    />
  );
}
